module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0036.jpg?v=5cfed6c0";